// src/api/reportAPI.js

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;
export const reportAPI = {
  // Generate audit report
  generateAuditReport: async (auditId, format) => {
    try {
      const response = await axios.post(`${API_BASE}/reports/audit/${auditId}`, 
        { format },
        { responseType: 'blob' }
      );
      return response.data;
    } catch (error) {
      console.error('Generate audit report error:', error);
      throw error;
    }
  },

  // Generate plant summary report
  generatePlantSummaryReport: async (plantId, format, dateRange) => {
    try {
      const response = await axios.post(`${API_BASE}/plants/${plantId}/summary`, 
        { format, dateRange },
        { responseType: 'blob' }
      );
      return response.data;
    } catch (error) {
      console.error('Generate plant summary report error:', error);
      throw error;
    }
  },

  // Generate comprehensive report
  generateComprehensiveReport: async (filters, format) => {
    try {
      const response = await axios.post(`${API_BASE}/reports/comprehensive`, 
        { filters, format },
        { responseType: 'blob' }
      );
      return response.data;
    } catch (error) {
      console.error('Generate comprehensive report error:', error);
      throw error;
    }
  },

  // Download report
  downloadReport: (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};